import { call, put, select, takeLatest } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import { MULTISITE_SELECTOR_EDITED, MULTISITE_SELECTOR_ITEMS, MULTISITE_SELECTOR_ORDER, PROGRAM_CINEMAS } from "../../constants/state"
import getData from "../../functions/getData"
import isEmptyObj from "../../functions/isEmptyObj"
import naturalCompare from "../../functions/naturalCompare"
import { putError, putSuccess } from "../helpers"


const selectData = state => ({
    edited: getData(state, MULTISITE_SELECTOR_EDITED),
    items: getData(state, MULTISITE_SELECTOR_ITEMS).toJS(),
    order: getData(state, MULTISITE_SELECTOR_ORDER).toJS(),
    cinemas: getData(state, PROGRAM_CINEMAS).toJS()
})


function* getCinemaPksFromSelectorCinemaObjects(items, order)  {
    const orderLength = yield order.length
    const cinemaPks = yield []
    const cinemaToItemPks = yield {}

    for(let i = yield 0; yield i < orderLength; yield i++) {
        const item = yield items[order[i]]
        
        if('cinemaObject' === item.type) {
            yield cinemaPks.push(item.cinemaPk)
            yield cinemaToItemPks[item.cinemaPk] = item.pk
        }
    }

    return yield {
        selectorCinemaObjectsPks: cinemaPks,
        cinemaToItemPks: cinemaToItemPks
    }
}

function* putNewItem(cinemaPk)  {
    yield put({
        type: actionTypes.MULTISITE_SELECTOR_ITEM_ADD_CINEMA_OBJ,
        meta: {},
        payload: {
            cinemaPk: cinemaPk
        }
    })
}

function* putDeleteItem(pk) {
    yield put({
        type: actionTypes.MULTISITE_SELECTOR_ITEM_REMOVE,
        meta: {},
        payload: {
            pk: pk
        }
    })
}

function* getSortedCinemasOrder(cinemas, cinemasOrder) {
    yield cinemasOrder.sort((a, b) => naturalCompare(cinemas[a].nameDisplay, cinemas[b].nameDisplay))

    return yield cinemasOrder
}

function* addAllCinemas(cinemas, cinemasOrder)  {
    const newOrder = yield call(getSortedCinemasOrder, cinemas, cinemasOrder)
    const newOrderLength = yield newOrder.length

    for(let i = yield 0; yield i < newOrderLength; yield i++) {
        const cinemaPk = yield newOrder[i]
        yield call(putNewItem, cinemaPk)
    }
}

function* getCinemaPksToDelete(cinemas, selectorCinemaObjectsPks)  {
    const cinemasPks = yield Object.keys(cinemas)
    const set2 = yield new Set(cinemasPks)


    if(selectorCinemaObjectsPks.every(item => set2.has(item))) {
        return yield false
    } else {
        return yield selectorCinemaObjectsPks.filter(item => !set2.has(item))
    }
}

function* deleteCinemas(cinemaPksToDelete, cinemaToItemPks) {
    const pksLength = yield cinemaPksToDelete.length

    for(let i = yield 0; yield i < pksLength; yield i++) {
        const cinemaPk = yield cinemaPksToDelete[i]
        const itemPk = yield cinemaToItemPks[cinemaPk]
        yield call(putDeleteItem, itemPk)
    }
}

function* filterMultisiteSelector() {
    try {
        yield put({
            type: actionTypes.MULTISITE_SELECTOR_FILTER_REQUEST,
            payload: {}
        })

        const data = yield select(selectData)
        const { edited, items, order, cinemas} = yield data
        let doUpdate = yield false
        const hasCinemas = !isEmptyObj(cinemas)

        if('init' === edited && order.length === 0 && hasCinemas) {      
            yield call(addAllCinemas, cinemas, Object.keys(cinemas))
            doUpdate = yield true
        } else if(hasCinemas) {
            const { selectorCinemaObjectsPks, cinemaToItemPks } = yield call(getCinemaPksFromSelectorCinemaObjects, items, order)
            const cinemaPksToDelete = yield call(getCinemaPksToDelete, cinemas, selectorCinemaObjectsPks)

            if(false != cinemaPksToDelete) { 
                yield call(deleteCinemas, cinemaPksToDelete, cinemaToItemPks)
                doUpdate = yield true
            }
        }

        if(doUpdate)  {
            yield put({
                type: actionTypes.MULTISITE_SELECTOR_UPDATE_REQUEST,
                payload: {}
            })
        }

        yield call(putSuccess, actionTypes.MULTISITE_SELECTOR_FILTER_SUCCESS, false)

    } catch(e)  {
        yield call(putError, actionTypes.MULTISITE_SELECTOR_FILTER_ERROR, e.message)
    }
}

function* watchMultisiteSelectorFilterRequest() {
    yield takeLatest(actionTypes.MULTISITE_SELECTOR_GET_SUCCESS, filterMultisiteSelector);
}

export default watchMultisiteSelectorFilterRequest